import React from 'react'
import styled from 'styled-components'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import { RAG } from 'features/dashboard/charts/scoreColour'

export const FALLBACK_FAILURE_REASON = 'We could not save this file. Please try uploading it again.'

export const failureLabel = count => (count === 1 ? '1 upload could not be saved' : `${count} uploads could not be saved`)

export const resultDialogState = ({ status, failureCount = 0, checking = false }) => ({
  showKeepOpen: checking && failureCount === 0,
  showSafeToClose: !checking && failureCount === 0 && status === 'success',
  retryIsPrimary: failureCount > 0
})

export const leaveUploadResult = ({ closeSummary, goBack }) => {
  if (typeof window !== 'undefined' && window.opener) {
    window.close()
    return
  }
  closeSummary?.()
  goBack?.()
}

export const completionSheetTitle = (status, failureCount = 0) => {
  if (failureCount > 0) return 'Some files could not be saved'
  if (status === 'success') return 'Upload received'
  if (status === 'partial') return 'Upload received with problems'
  return 'Upload did not work'
}

const UploadFailuresList = ({ failures = [], onRetry, retryLabel = 'Choose files again' }) => {
  if (!failures.length) return null
  return (
    <Wrap>
      <List aria-label='Files that could not be saved'>
        {failures.map(failure => (
          <Row key={failure.id}>
            <Status>
              <ErrorOutlineRoundedIcon aria-hidden='true' style={{ fontSize: 18 }} />
              <span>Could not be saved</span>
            </Status>
            <Name>{failure.displayName || 'Unnamed file'}</Name>
            <Reason>{failure.reason || FALLBACK_FAILURE_REASON}</Reason>
          </Row>
        ))}
      </List>
      {onRetry && (
        <RetryButton type='button' onClick={onRetry}>{retryLabel}</RetryButton>
      )}
    </Wrap>
  )
}

export default UploadFailuresList

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Row = styled.li`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid ${RAG.critical.fg}33;
  border-left: 4px solid ${RAG.critical.fg};
  border-radius: 8px;
  background: ${RAG.critical.bg};
  min-width: 0;
`

const Status = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 700;
  color: ${RAG.critical.fg};
`

const Name = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #1c1c22;
  overflow-wrap: anywhere;
`

const Reason = styled.span`
  font-size: 14px;
  line-height: 1.45;
  color: #3f3f46;
  overflow-wrap: anywhere;
`

const RetryButton = styled.button`
  align-self: flex-start;
  min-height: 44px;
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  background: #33becc;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;

  @media (max-width: 480px) {
    align-self: stretch;
  }
`
